import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select"]

  change(event) {
    const changed = this.selectTargets.indexOf(event.target)
    this.selectTargets.slice(changed + 1).forEach((select) => { select.value = "" })
    this.element.requestSubmit()
  }
}
